import React from "react";

import {
  FontIcon,
  mergeStyles,
  mergeStyleSets,
  useTheme
} from "@bps/fluent-ui";
import {
  CompoundButtonWithError,
  CompoundButtonWithErrorProps
} from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/CompoundButtonWithError.tsx";

interface ExpanderButtonProps<T> extends CompoundButtonWithErrorProps<T> {
  isOpened: boolean;
}
export const ExpanderButton = <T extends object>({
  isOpened,
  children,
  ...props
}: ExpanderButtonProps<T>) => {
  const theme = useTheme();
  const showDisabledIconColor = props.disabled
    ? theme.semanticColors.disabledText
    : theme.palette.themePrimary;
  return (
    <CompoundButtonWithError<T>
      {...props}
      styles={mergeStyleSets(
        {
          root: {
            backgroundColor: isOpened ? theme.palette.neutralLight : undefined
          },
          flexContainer: {
            "i:not([data-icon-name=Contact])": {
              color: showDisabledIconColor
            },
            span: {
              color: props.disabled
                ? theme.semanticColors.disabledText
                : theme.palette.black
            }
          }
        },
        props.styles
      )}
      hasBorder={false}
    >
      <FontIcon
        iconName={isOpened ? "ChevronLeft" : "ChevronRight"}
        className={mergeStyles({
          color: showDisabledIconColor
        })}
      />
      {children}
    </CompoundButtonWithError>
  );
};
